"use client";
import { jsxs as s, Fragment as _, jsx as a } from "react/jsx-runtime";
import { useSlottedTemplate as p } from "../../hooks/use-slotted-template/use-slotted-template.js";
import d from "clsx";
import { Slot as u } from "@radix-ui/react-slot";
import '../../assets/tab.css';const o = {
  "tab-control": "_tab-control_1i2mb_1",
  "tab-control--active": "_tab-control--active_1i2mb_39",
  "tab-control__label": "_tab-control__label_1i2mb_47",
  "tab-control--full-width": "_tab-control--full-width_1i2mb_60"
}, f = ({
  icon: t,
  children: l
}) => /* @__PURE__ */ s(_, { children: [
  t && /* @__PURE__ */ a("span", { children: t }),
  /* @__PURE__ */ a("span", { className: o["tab-control__label"], children: l })
] }), g = ({
  children: t,
  className: l,
  asChild: r,
  active: n,
  icon: c,
  width: e,
  ...b
}) => {
  const i = r ? u : "button", m = p({
    children: t,
    asChild: r,
    template: f,
    props: { icon: c }
  });
  return /* @__PURE__ */ a(
    i,
    {
      className: d(l, {
        [o["tab-control"]]: !0,
        [o["tab-control--active"]]: n,
        [o["tab-control--full-width"]]: e === "full-width"
      }),
      "aria-current": n ? "page" : void 0,
      role: r ? "tab" : void 0,
      ...b,
      children: m
    }
  );
};
export {
  f as Child,
  g as Tab
};
